import { SortColorsBy } from '../common/constants';

export const colorSortOptions = [
  {
    value: SortColorsBy.TopSellers,
    label: 'Top Sellers',
  },
  {
    value: SortColorsBy.NameAsc,
    label: 'Name A - Z',
  },
  {
    value: SortColorsBy.NameDesc,
    label: 'Name Z - A',
  },
  {
    value: SortColorsBy.PriceDesc,
    label: 'Price High to Low',
  },
  {
    value: SortColorsBy.PriceAsc,
    label: 'Price Low to High',
  },
];
